import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/logistics-supply-chain-dashboard/components/LogisticsDashboardInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/AppLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/RouteGuard.tsx");
